import dayjs from 'dayjs';
import { TFunction } from 'i18next';

/** Every `maintenance.*` key the banner uses; the locale test checks all five languages against it. */
export const MAINTENANCE_LOCALE_KEYS = [
  'planned_title',
  'planned_copy',
  'running_title',
  'running_overdue_title',
  'running_copy_portal',
  'running_copy_login',
  'done_title',
  'done_copy',
  'unreachable_title',
  'unreachable_copy',
  'dismiss',
  'day_today',
  'day_tomorrow',
  'date_format',
] as const;

/** Hours and minutes in the browser's local time. */
export const formatMaintenanceTime = (iso: string): string => dayjs(iso).format('HH:mm');

/** "today", "tomorrow" or a short localized date for the start of the window. */
export const formatMaintenanceDay = (startIso: string, now: number, t: TFunction): string => {
  const start = dayjs(startIso);
  const today = dayjs(now);
  if (start.isSame(today, 'day')) return t('maintenance.day_today');
  if (start.isSame(today.add(1, 'day'), 'day')) return t('maintenance.day_tomorrow');
  return start.format(t('maintenance.date_format'));
};
